import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChecklistSummaryComponent } from './checklist-summary.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'pending',
    pathMatch: 'full'
  },
  {
    path: 'pending',
    component: ChecklistSummaryComponent,
  },
  {
    path: 'completed',
    component: ChecklistSummaryComponent,
  },
  {
    path: 'search',
    component: ChecklistSummaryComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChecklistSummaryRoutingModule { }
